import { RequestEditDueDateModalDateField } from '../RequestEditDueDateModalDateField'

function RequestEditDueDateModalFields(props) {
  return <RequestEditDueDateModalDateField {...props} />
}

export default RequestEditDueDateModalFields
